import React from "react";
import "./loader.scss";

export default function() {
  return <div className="loader" />;
}
